// extracted by mini-css-extract-plugin
export default {"sectionGroup":"X5Bw5KWU3YZyoVMxcwiG","metrics":"zySqM_UsndUhFeMGSpsF","memberMetrics":"lvH7ww6ny33_iEOSCxLm","riskMembers":"CXWJcbjLebdL8l4GsZA6"};